import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { ProductSizesState } from '../types'
import featureStateSelector from './featureStateSelector'

export const errorSelector = createSelector<ReduxState, ProductSizesState, string | undefined>(
  featureStateSelector,
  state => state.UIState.error
)
